import { AxiosResponse } from 'axios';
import { api } from '../api';
import { StandardResponse } from '../interfaces/Common';
import { DashboardData } from '../interfaces/Dashboard';

export async function dashboard(params?: { videosProgramId?: string; referencesProgramId?: string; usersProgramId?: string; }): Promise<StandardResponse<DashboardData>> {
    const response: AxiosResponse<StandardResponse<DashboardData>> = await api.get("/dashboard/admin", {
        params
    });
    return response.data;
}